// extracted by mini-css-extract-plugin
export default {"container":"KM-z","topReviewHeading":"LM-z","criticalReview":"MM-z","favorableReview":"NM-z","vsSeparator":"OM-z"};